import { Injectable } from '@angular/core'
import { NavigationStart, Router } from '@angular/router'
import { GetCurrentVersionQuery } from '@app/shared/queries/get-current-version.query'
import { filter, tap } from 'rxjs'

const VERSION_STORAGE_PREFIX = '_gx_version'
const NOW_STORAGE_PREFIX = '_gx_now'
const TIME_PASSED_MS = 300000

@Injectable({ providedIn: 'root' })
export class VersionCheckService {
  constructor(
    private router: Router,
    private getCurrentVersionQuery: GetCurrentVersionQuery
  ) {}

  get versionStorage(): string | null {
    return localStorage.getItem(VERSION_STORAGE_PREFIX)
  }
  set versionStorage(val: string) {
    localStorage.setItem(VERSION_STORAGE_PREFIX, val)
  }
  get nowStorage(): number | null {
    const now = sessionStorage.getItem(NOW_STORAGE_PREFIX)
    return now ? +now : null
  }
  set nowStorage(val: string) {
    sessionStorage.setItem(NOW_STORAGE_PREFIX, val)
  }

  init(): void {
    this.getCurrentVersionQuery.call().subscribe((version) => {
      this.versionStorage = version
      this.nowStorage = Date.now().toString()

      this.listenRouterEvents()

      window.addEventListener('storage', (event) => {
        if (event.key === VERSION_STORAGE_PREFIX) {
          window.location.reload()
        }
        if (event.key === NOW_STORAGE_PREFIX) {
          this.nowStorage = Date.now().toString()
        }
      })
    })
  }

  private listenRouterEvents(): void {
    this.router.events
      .pipe(
        filter((event) => event instanceof NavigationStart),
        filter(() => Date.now() - this.nowStorage! > TIME_PASSED_MS)
      )
      .subscribe((_event) => {
        const event = _event as NavigationStart

        this.getCurrentVersionQuery.call().subscribe((version) => {
          const currentVersion = localStorage.getItem(VERSION_STORAGE_PREFIX)

          if (currentVersion !== version) {
            window.location.href = event.url
          } else {
            this.versionStorage = version
            this.nowStorage = Date.now().toString()
          }
        })
      })
  }
}
